import { addModal } from 'weblite-web-modal-viewer'
import { VideoPlayerModal } from './video-player-modal'

const COMPONENT_ID = 'videoPlayer'

export const showVideoPlayerModal = (
  props: Parameters<typeof VideoPlayerModal>[0],
) => addModal({ id: COMPONENT_ID, closeImmediately: true, props })

export default {
  [COMPONENT_ID]: {
    Component: VideoPlayerModal,
  },
}
